import { useAuthState } from "./authContext";

type WebAccessState =
  | { status: "loading" }
  | { status: "allowed" }
  | { status: "basic" }
  | { status: "studentBasic" };

export function useWebAccess(): WebAccessState {
  const auth = useAuthState();
  const correctAuthType =
    auth.type === "signedIn" && auth.user.type === "student";

  // Not signed in or not a student ‚Üí no web access
  if (!correctAuthType) {
    return { status: "basic" };
  }
  // Same cast used in BaseViewStudent
  const { user } = auth;
  const hasWeb = user?.currentAccess?.includes("WEBSITE_VOX") ?? false;

  return { status: hasWeb ? "allowed" : "studentBasic" };
}
